export const LABELS_VOYAGE_PLANNING = {
    voyageStatuses: {
        COMPLETED_IN_TIME: "Завершений вчасно",
        COMPLETED_AHEAD: "Завершений достроково",
        COMPLETED_LATENESS: "Завершений з запізненням",
        EXPIRED: "Протерміновано",
        INTERRUPTED: "Перервано",
        RUN: "В рейсі",
        RUN_AHEAD: "В рейсі достроково",
        RUN_LATENESS: "В рейсі з запізненням",
        RUN_WITH_DEFLECTION: "В рейсі(deflection)",
        CREATED: "Новопризначений",
        REGISTERED: "Зареєстрований",
        DRAFTED: "Зїхав з маршруту",
        IDLE: "Idle",
    },
    releaseNumbers: "Номери випусків",
    saveMode: "Режим збереження",
    finishedVoyages: {
        title: "Раніше на цьому випуску:",
        markerFinished: "{{plate}}, перервано о {{time}}",
        markerReplaced: "Заміна о {{time}}: {{from}} → {{to}}",
        itemFinished: "{{plate}}, {{driver}}: завершено о {{time}}",
        itemReplaced: "Заміна о {{time}}: {{from}} → {{to}}",
        by: "({{name}})",
        noDriver: "без водія",
        assignSame: "Призначити це ж ТЗ",
    },
    list: {
        notAssigned: "Не призначено",
        noDriver: "Водій не призначений",
        empty: "Нічого не знайдено",
    },
    // What each sidebar button does, shown on hover.
    hints: {
        localSave: "Як у старому плануванні: зміни збираються як чернетка і потрапляють у систему лише після «Зберегти зміни».",
        serverSave: "Кожна зміна у вікні рейсу одразу зберігається в системі. Тут також можна заповнити наряд на кілька днів наперед.",
        change: "Показати план для обраного перевізника і дат.",
        refresh: "Завантажити план заново, щоб побачити зміни інших диспетчерів.",
        saveChanges: "Відправити в систему всі ваші зміни одразу, без перегляду.",
        checkAndSave: "Спершу показати список: що буде додано, змінено чи видалено. Зберегти можна після перегляду.",
        clearLocalSlots: "Скасувати всі незбережені зміни. План повернеться до того, що вже є в системі.",
        voyageLetter: "Відкрити PDF шляхових листів у новій вкладці: для обраного маршруту або для всіх показаних.",
        dayOutfit: "Відкрити PDF денного наряду в новій вкладці: для обраного маршруту або для всіх показаних.",
        driverSchedule: "Завантажити PDF із розкладом зупинок по кожному випуску — для водіїв.",
        releaseNumbers: "Показувати номер випуску в клітинках таблиці.",
    },
}
